import { AxiosResponse } from 'axios';

import { statusPageUrl } from '@utils';

import { client } from '../client';

import { accountEndPoints } from './endpoints';
import {
  CustomerLoginPayload,
  CustomerLoginResponse,
  FetchPoliciesResponse,
  OtpPayload,
  OtpResponse,
  SendPolicyOTPRequest,
  SendPolicyOTPResponse,
  VerifyPolicyOTPRequest,
  VerifyPolicyOTPResponse
} from './types';

export const accountAPIs = {
  sendOTP: (payload: OtpPayload): Promise<AxiosResponse<OtpResponse>> => {
    return client.post<OtpResponse, OtpPayload>(accountEndPoints.sendOtp, {
      ...payload
    });
  },
  sendWhatsAppOTP: (payload: OtpPayload): Promise<AxiosResponse<OtpResponse>> => {
    return client.post(accountEndPoints.sendWhatsappOtp, { ...payload });
  },
  customerLogin: (
    payload: CustomerLoginPayload
  ): Promise<AxiosResponse<CustomerLoginResponse>> => {
    return client.post<CustomerLoginResponse, CustomerLoginPayload>(
      accountEndPoints.customerLogin,
      payload
    );
  },
  fetchPolicies: (): Promise<AxiosResponse<FetchPoliciesResponse>> => {
    return client.get<FetchPoliciesResponse>(accountEndPoints.policies);
  },
  customerLogout: (): Promise<AxiosResponse<CustomerLoginResponse>> => {
    return client.post<CustomerLoginResponse, any>(accountEndPoints.customerLogout);
  },
  sendPolicyOTP: (payload: SendPolicyOTPRequest): Promise<SendPolicyOTPResponse> => {
    return client.post(accountEndPoints.sendPolicyOTP, payload);
  },
  verifyPolicyOTP: (
    payload: VerifyPolicyOTPRequest
  ): Promise<VerifyPolicyOTPResponse> => {
    return client.post(accountEndPoints.verifyPolicyOTP, payload);
  },
  checkUserAuth: (
    policyID: string,
    data: { phone_num: string; otp: string; country_code: string }
  ): Promise<AxiosResponse<FetchPoliciesResponse>> => {
    const app = statusPageUrl(window.location.href);
    return client.post(accountEndPoints.verifyUser(app || '', policyID), data);
  }
};
